// extracted by mini-css-extract-plugin
export default {"title":"title__072fb5","header":"header__e5e0ce","buttonContainer":"buttonContainer__b79c64","buttonsRight":"buttonsRight__505d9e","button":"button__69f9ae"};